module.exports = __webpack_public_path__ + "static/media/scribbbleLogoPink.a2eff734.png";